import { render, staticRenderFns } from "./CattelanitaliaLogo.vue?vue&type=template&id=58322f03&"
var script = {}
import style0 from "./CattelanitaliaLogo.vue?vue&type=style&index=0&csoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports